import { render, staticRenderFns } from "./ApiInvoicesTable.vue?vue&type=template&id=81628138&"
import script from "./ApiInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./ApiInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports